import React from 'react';

const InvoiceComponentFK = () => {
    return (
        <div>

        </div>
    );
};

export default InvoiceComponentFK;